import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const InsertTab = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 18 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fill={color}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.0905 8.9999C16.0905 9.27604 15.8666 9.4999 15.5905 9.4999H9.50008V15.5903C9.50008 15.8665 9.27622 16.0903 9.00008 16.0903C8.72394 16.0903 8.50008 15.8665 8.50008 15.5903V9.4999H2.40967C2.13353 9.4999 1.90967 9.27604 1.90967 8.9999C1.90967 8.72376 2.13353 8.4999 2.40967 8.4999H8.50008V2.40948C8.50008 2.13334 8.72394 1.90948 9.00008 1.90948C9.27622 1.90948 9.50008 2.13334 9.50008 2.40948V8.4999H15.5905C15.8666 8.4999 16.0905 8.72376 16.0905 8.9999Z"
      />
    </svg>
  )
})

export default InsertTab
